import { Modal } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import CustomModalHeader from './customModalHeader';
import GroupButton from '../button/groupButton';
import { resetPassword } from 'api/userApi';
import { useMutation } from 'react-query';
import { messageErrors } from '../../utils/utils';
import _ from 'lodash';
import 'styles/styles.scss';
import { useForm } from 'react-hook-form';

type changePasswordModalTypes = {
  openModal: boolean,
  setOpenModal: Function,
  closeModal?: Function
};

const ChangePasswordModal = (props: changePasswordModalTypes) => {
  const [t] = useTranslation();
  const { openModal, setOpenModal, closeModal } = props;
  const mutation = useMutation('changePassword', { mutationFn: resetPassword });
  const {
    handleSubmit
  }:any = useForm({
  });
  const onSubmit = () => {
    mutation.mutate(
      {},
      {
        onSuccess: () => {
          setOpenModal(!openModal);
          if (closeModal) {
            closeModal()
          }
          const message: string = t('changePassword.messageSuccess');
          toast.success(message);
        },
        onError: (error: any) => {
          const message: string = messageErrors(error, t);
          toast.error(message);
        },
      },
    );
  };

  const cancelHandler = () => {
    setOpenModal(!openModal);
  };

  return (
    <Modal show={openModal} size="xl" popup={true} className="h-full-important modal-change-password">
      <form onSubmit={handleSubmit(onSubmit)}>
        <CustomModalHeader title={t('changePassword.title')} toggle={cancelHandler} />
        <Modal.Body>
          <div className="flex flex-col px-4 gap-4">
            <div className="font-light text-center font-semibold text-gray-900 dark:text-gray-300">{t('changePassword.sureResetPasswordTitle')}</div>
            <div className="font-light text-center">{t('changePassword.sureResetPasswordContent')}</div>
            <GroupButton
              className="items-center justify-center pt-1 pb-2"
              buttons={[
                {
                  type: 'button',
                  text: t('modal.cancel'),
                  classType: 'white',
                  action: () => cancelHandler(),
                },
                {
                  type: 'submit',
                  text: 'Yes',
                  classType: 'blue',
                  isLoading: mutation.isLoading,
                },
              ]}
            />
          </div>
        </Modal.Body>
      </form>
    </Modal>
  );
};
export default ChangePasswordModal;
